import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Box, Button, Card, Stack, Typography, useTheme } from "@mui/material";

import { useModalManager } from "../../Common/CloudflowModalsProvider";
import { useCloudflowOperations } from "../../Common/CloudflowOperationsProvider";
import { NodeCardHeader } from "./NodeCardHeader";

export const ManualTriggerTab = () => {
  const { httpOperationLoading } = useCloudflowOperations();

  const {
    palette: { primary },
  } = useTheme();
  const { openModal } = useModalManager();

  return (
    <Box>
      <Stack
        sx={{
          p: 2,
          justifyContent: "center",
          gap: 2,
        }}
      >
        <Card sx={{ "&:hover": { borderColor: primary.main } }}>
          <NodeCardHeader
            avatar={<AccountCircleIcon color="primary" />}
            subheader="Triggered manually by the user"
            title="Manual"
            action={
              <Button
                disabled={httpOperationLoading}
                onClick={() => {
                  openModal("trigger");
                }}
              >
                Change
              </Button>
            }
          />
        </Card>
        <Typography
          variant="subtitle2"
          sx={{
            color: "text.primary",
            fontWeight: 500,
          }}
        >
          About Manual CloudFlow triggers
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
          }}
        >
          A manual trigger allows you to start this CloudFlow whenever you choose. When a CloudFlow is published, you
          can trigger it by clicking the ‘Run’ button in the top bar of the CloudFlow editor.
        </Typography>
      </Stack>
    </Box>
  );
};
